module.exports = __webpack_public_path__ + "static/assets/6e28e7c0a45c953cf6dd197c7f272b31.svg";